import React from "react";

type Props = {};

// eslint-disable-next-line no-empty-pattern
export default function ZoomSearchIcon(props: Props) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.0068 21L15.864 15.8571M10.7211 18.4286C6.46064 18.4286 3.00684 14.9748 3.00684 10.7143C3.00684 6.4538 6.46064 3 10.7211 3C14.9816 3 18.4354 6.4538 18.4354 10.7143C18.4354 14.9748 14.9816 18.4286 10.7211 18.4286Z"
        stroke="#1D1929"
        strokeWidth="1.75"
      />
    </svg>
  );
}
